
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M3.72001 6.04C4.19001 6.5 4.93001 6.52 5.43001 6.1C5.80001 5.78 6.12001 5.59 6.30001 5.67C6.80001 5.87 6.30001 6.7 6.00001 7.19C5.75001 7.61 3.14001 11.08 3.14001 13.5C3.14001 14.78 3.62001 15.84 4.48001 16.48C5.23001 17.04 6.22001 17.21 7.12001 16.94C8.19001 16.63 9.07001 15.54 10.18 14.17C11.39 12.68 13.01 10.73 14.26 10.73C15.89 10.73 15.91 11.74 16.02 12.52C12.24 13.16 10.64 16.19 10.64 17.89C10.64 19.59 12.08 20.98 13.85 20.98C15.48 20.98 18.14 19.65 18.54 14.88H19.75C20.44 14.88 21 14.32 21 13.63C21 12.94 20.44 12.38 19.75 12.38H18.53C18.38 10.73 17.44 8.18 14.5 8.18C12.25 8.18 10.32 10.09 9.56001 11.02C8.98001 11.75 7.50001 13.5 7.27001 13.74C7.02001 14.04 6.59001 14.58 6.16001 14.58C5.71001 14.58 5.44001 13.75 5.80001 12.66C6.15001 11.57 7.20002 9.8 7.65001 9.14C8.43001 8 8.95001 7.22 8.95001 5.86C8.95001 3.69 7.31001 3 6.44001 3C5.35001 3 4.40001 3.63 3.74001 4.22C3.21001 4.7 3.21001 5.54 3.72001 6.04ZM13.88 18.55C13.57 18.55 13.14 18.29 13.14 17.83C13.14 17.23 13.87 15.63 16.01 15.07C15.71 17.76 14.58 18.55 13.88 18.55Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-gesture`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconGesture

    ```js
    <b-new-b-icon-gesture />
    ```
</docs>


